export const SEND_CMD_CREDENTIALS = 'qes/SEND_CMD_CREDENTIALS';
export const SEND_CMD_CREDENTIALS_URL = '/startQES';
export const VALIDATE_OPT = 'qes/VALIDATE_OPT';
export const VALIDATE_OTP_URL = '/completeQES';
